import React from 'react';
import {
    Row,
    Col,
    Form,
    Checkbox,
    InputNumber,
    Divider,
} from 'antd';
import FormStepTitle from '../FormStepTitle';
import FormStepButton from '../FormStepButton';
import { createAddonLabelsAndTotal } from '../../../utils';
import { ADDONS, ADDONS_LIST } from '../../../constants/servicesList';


const FormStepAddons = props => {
    const { formItemLayout, form, submitStep } = props;
    const { getFieldDecorator } = form;

    const handleSubmit = e => {
        e.preventDefault();

        props.form.validateFields((_, values) => {
            const { labels, total } = createAddonLabelsAndTotal(values.list, values.valeuxWindowQuantity);

            submitStep({ addonsList: labels, addonsCharge: total });
        });
    };

    return (
        <Row gutter={40}>
            <Col span={24}>
                <Form onSubmit={handleSubmit} {...formItemLayout}>
                    <FormStepTitle label="Please select any additional services" />
                    <Form.Item>
                        {
                            getFieldDecorator('list') (
                                <Checkbox.Group>
                                    <Row>
                                        {
                                            ADDONS_LIST.map(({ id, price, label }) =>
                                                <Col key={id} sm={24} md={12} style={{ marginBottom: 16 }}>
                                                    <Checkbox value={label}>
                                                        { `£${price} - ${label}` }
                                                    </Checkbox>
                                                </Col>
                                            )
                                        }
                                    </Row>
                                </Checkbox.Group>
                            )
                        }
                    </Form.Item>
                    <Divider />
                    <Form.Item label={`£${ADDONS.velux_roof_window.price} - ${ADDONS.velux_roof_window.label} (price per window)`}>
                        {
                            getFieldDecorator('valeuxWindowQuantity', { initialValue: 0 }) (
                            <InputNumber min={0} max={10} />)
                        }
                        <span>
                            &nbsp;Quantity
                        </span>
                    </Form.Item>
                    <FormStepButton />
                </Form>
            </Col>
        </Row>
    );
};

export default Form.create({ name: 'addons' })(FormStepAddons);
